import { getOr, map } from 'lodash/fp';
import { all, call, put } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchInventoryLocation as fetchInventoryLocationRoutine,
  fetchInventoryLocations as fetchInventoryLocationsRoutine,
  createInventoryLocation as createInventoryLocationRoutine,
  updateInventoryLocation as updateInventoryLocationRoutine,
  deleteInventoryLocation as deleteInventoryLocationRoutine
} from './routines';
import { updateInventoryLocationZones } from '../../actions/location';
import { createInventoryLocationZone } from '../location-zone';
import history from '../../../../routes/history';
import { inventoryLocationsPath } from '../../../../routes/Paths';

export const fetchInventoryLocation = ({ payload: { id } }) =>
  sagaRoutineRequest(fetchInventoryLocationRoutine, {
    request: () => call(Api.fetchInventoryLocation, id)
  });

export const fetchInventoryLocations = ({ payload: qs }) =>
  sagaRoutineRequest(fetchInventoryLocationsRoutine, {
    request: () => call(Api.fetchInventoryLocations, { qs })
  });

export const createInventoryLocation = ({ payload: { location, zones } }) =>
  sagaRoutineRequest(createInventoryLocationRoutine, {
    request: () => call(Api.createInventoryLocation, { body: location }),
    *success(response) {
      const { id: inventoryLocationId, name } = response;
      yield toastr.success('Success', `${name} location created!`);
      const locationZones = yield all(
        map(
          zone =>
            call(createInventoryLocationZone, {
              payload: { ...zone, inventoryLocationId }
            }),
          zones
        )
      );
      yield put(updateInventoryLocationZones(locationZones));
      history.push(inventoryLocationsPath);
    },
    *failure({ error, message }) {
      const errDetails = getOr(message, '0.message', error);
      yield toastr.error(
        'Oops!',
        `Unable to create location ${location.name}. ${errDetails}`
      );
    }
  });

export const updateInventoryLocation = ({ payload: { location, zones } }) =>
  sagaRoutineRequest(updateInventoryLocationRoutine, {
    request: () =>
      call(Api.updateInventoryLocation, {
        id: location.id,
        body: { name: location.name }
      }),
    *success() {
      yield toastr.success('Success', `Location updated.`);
      const locationZones = yield all(
        map(
          zone =>
            call(createInventoryLocationZone, {
              payload: { ...zone, inventoryLocationId: location.id }
            }),
          zones
        )
      );
      yield put(updateInventoryLocationZones(locationZones));
      history.push(inventoryLocationsPath);
    }
  });

export const deleteInventoryLocation = ({ payload: { name, id } }) =>
  sagaRoutineRequest(deleteInventoryLocationRoutine, {
    request: () => call(Api.deleteInventoryLocation, id),
    successPayload: { id },
    *success() {
      yield toastr.success('Success', `Deleted location "${name}".`);
    }
  });
